<template>
    <v-container class="pa-0">
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        Stock - Available ({{model.stock}}) - On Hand ({{model.on_hand}}) - Pending ({{model.pending}}) - Incoming ({{model.incoming}})
                        <v-spacer />
                        <ReturnProduct :product="model" @refresh="$emit('refresh')">
                            <template v-slot:default="{on}">
                                <v-btn v-on="on" class="mr-2">Add location</v-btn>
                            </template>
                        </ReturnProduct>
                        <product-stock-log-detail v-model="model" />
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-data-table
                                    :headers="headers"
                                    :items="model.stockDetail"
                                    :item-class="itemRowBackground"
                                >
                                    <template #[`item.actions`]="{item}">
                                        <ReturnProduct :product="model" :location="item" @refresh="$emit('refresh')"/>
                                        <PickProduct :product="model" :location="item" @refresh="$emit('refresh')"/>
                                        <MoveProductLocation :product="model" :location="item" @refresh="$emit('refresh')"/>
                                    </template>
                                </v-data-table>
                            </v-col>
                            <v-col>
                                <div>
                                    <v-btn-toggle
                                        v-model="timeframe"
                                        tile
                                        color="deep-purple accent-3"
                                        group
                                    >
                                        <v-btn :value=3 text x-small>3 months</v-btn>
                                        <v-btn :value=6 text x-small>6 months</v-btn>
                                        <v-btn :value=12 text x-small>12 months</v-btn>
                                        <v-btn :value=24 text x-small>24 months</v-btn>
                                    </v-btn-toggle>
                                </div>
                                <HistoricChart :height=200 v-if="historics" :data="historics" />
                            </v-col>
                        </v-row>
                        
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        Pending orders with these products
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                            :headers="pendingOrderHeaders"
                            :items="pendingOrders"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    
    </v-container>
</template>

<script>
import ProductStockLogDetail from './ProductStockLogDetail.vue';
import ReturnProduct from "./ReturnProduct.vue"
import PickProduct from "./PickProduct.vue"
import MoveProductLocation from "./MoveProductLocation.vue"
import NewApiService from "@/utils/new.api.service";
import HistoricChart from '../graph/HistoricChart';
export default {
  components: { ProductStockLogDetail, ReturnProduct, PickProduct, MoveProductLocation, HistoricChart },
    data: () =>({
        headers:[
            { text: "Location", value: "location.location" },
            { text: "Quantity", value: "final" },
            { text: "Action", value: "actions" },
        ],
        pendingOrders : [],
        pendingOrderHeaders:[
            { text: "ID", value:"id"},
            { text: "Client", value:"client.displayName"},
            { text: "Order Status", value:"statusId"},
            { text: "Invcoice Status", value:"invoice.statusId"},
            { text: "Build Status", value:"build.status_id"},
        ],
        historics: null,
        timeframe: 3
    }),
    props:{
        value:{
            type: Object,
            required: true
        }
    },
    computed:{
        model:{
            get(){
                return this.value;
            },
            set(value){
                this.$emit('input',value);
            }
        }
    },
    watch: {
        timeframe () {
            this.getHistoric();
        }
    },
    mounted(){
        this.getPendingOrders();
        this.getHistoric();
    },
    methods:{
        itemRowBackground: function (item) {
            return item.location.reserveLocation ? 'reserveLocation' : ''
        },
        getPendingOrders(){
            NewApiService.get('products/'+this.model.id+'/pending-order')
            .then(({data}) => {
                this.pendingOrders = data.orders;
            } )
        },
        getHistoric() {
            NewApiService.get(`products/${this.model.id}/historic`, {timeframe: this.timeframe})
            .then(({data}) => {
                this.historics = data.historics
            })
        },
        open(){}
    }
}
</script>

<style lang="less">
    .reserveLocation td{
        background: #a9b0e1;
    }
</style>